import React, { useState, useEffect, useRef } from 'react';
import { ENV, SITE_URL } from '../../../config/index.js';
import { useLocation } from 'react-router-dom';

const Header = ({
  userName,
  // currentView,
  handleViewChange,
  handleSignOut,
  sidebarOpen,
  mobileSidebarOpen,
  toggleSidebar,
  toggleHelp,
  helpOpen
}) => {
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const location = useLocation();
  const path = location.pathname;
  const buttonRef = useRef(null);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setIsDropdownVisible((prevState) => !prevState);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setIsDropdownVisible(false);
      }
    };

    document.addEventListener('click', handleClickOutside, true);

    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, []);

  const handleSignOutClick = () => {
    handleSignOut();
    setIsDropdownVisible(false);
  };

  const handleHelpClick = () => {
    toggleHelp();
  };

  // console log currentView
  // useEffect(() => {
  //   console.log(currentView);
  // }, [currentView]);

  return (
    <div className="fuselight-v5-header">
      <div
        className={
          sidebarOpen && mobileSidebarOpen
            ? 'header-logo-container sidebar-open mobile-sidebar-open'
            : sidebarOpen
            ? 'header-logo-container sidebar-open'
            : mobileSidebarOpen
            ? 'header-logo-container mobile-sidebar-open'
            : 'header-logo-container'
        }
      >
        <button className="logo-button" onClick={toggleSidebar}>
          <img
            src={
              ENV === 'development'
                ? `${SITE_URL}/app/themes/hahn/images/logo/FuseLightLogoWithName.svg`
                : `${SITE_URL}/wp-content/themes/hahn/images/logo/FuseLightLogoWithName.svg`
            }
            alt="Fuselight Logo"
            className="header-logo"
            width={180}
          />
          <img
            src={
              ENV === 'development'
                ? `${SITE_URL}/app/themes/hahn/images/logo/FuseLightLogo.svg`
                : `${SITE_URL}/wp-content/themes/hahn/images/logo/FuseLightLogo.svg`
            }
            alt="Fuselight Logo Icon"
            className="header-logo-icon"
            width={30}
          />
          <div className="button-caret"></div>
          <div className="button-caret-mobile">
            <div></div>
            <div></div>
          </div>
        </button>
      </div>
      <div
        className={
          sidebarOpen && mobileSidebarOpen
            ? 'header-account-container mobile-sidebar-open'
            : sidebarOpen
            ? 'header-account-container sidebar-open'
            : mobileSidebarOpen
            ? 'header-account-container mobile-sidebar-open'
            : 'header-account-container'
        }
      >
        {userName ? (
          <>
            {['/launchpad', '/fuse', '/project'].includes(path) && (
              <button
                className={helpOpen ? 'help-icon help-open' : 'help-icon'}
                onClick={handleHelpClick}
              >
                ?
              </button>
            )}

            <button
              className="circle-icon"
              onClick={toggleDropdown}
              ref={buttonRef}
            >
              {userName.charAt(0).toUpperCase()}
            </button>

            <div
              className={`account-dropdown ${
                isDropdownVisible ? 'visible' : ''
              }`}
              ref={dropdownRef}
            >
              <ul>
                <li>
                  <a href="/my-account/" target="_blank">
                    My account
                  </a>
                </li>
                <li>
                  <button onClick={handleSignOutClick}>Sign out</button>
                </li>
              </ul>
            </div>
          </>
        ) : (
          <>
            {path === '/login' ? (
              <button
                className="btn btn--secondary-outline"
                onClick={() => handleViewChange('launchpad')}
              >
                Launchpad
              </button>
            ) : (
              <button
                className="btn btn--secondary-outline"
                onClick={() => handleViewChange('login')}
              >
                Login
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Header;
